var _circle, _circle2, _circle3, _circle4, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommunitiesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2 8 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.725,
    cy: 19.215,
    r: 3.824,
    transform: "rotate(45.53 12.725 19.215)",
    stroke: "#242424",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.493,
    cy: 27.127,
    r: 1.912,
    transform: "rotate(45.53 20.493 27.127)",
    stroke: "#242424",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.912,
    transform: "scale(-1 1) rotate(-45.53 10.987 11.557)",
    stroke: "#242424",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.638,
    cy: 11.447,
    r: 1.912,
    transform: "rotate(-44.47 20.638 11.447)",
    stroke: "#242424",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#242424",
    strokeWidth: 1.5,
    d: "M15.529 21.819l3.75 3.82M10.172 16.362l-3.75-3.82M15.33 16.41l3.82-3.75"
  })));
}

export default SvgCommunitiesIcon;